import { AxiosInstance } from "axios";

export const convertToMinutes = (time: string): number => {
    const [hours, minutes, seconds] = time.split(":").map(Number);
    return Math.round(hours * 60 + minutes + seconds / 60);
};

export const deleteConcertEvent = async (
    axiosPrivate: AxiosInstance,
    idPlanu: number,
    concertVersion: number
) => {
    await axiosPrivate.delete(`/concertsSchedule/${idPlanu}`, {
        data: { wersja: concertVersion },
    });
};

export const fetchData = async (
    axiosPrivate: AxiosInstance,
    concertId: number
) => {
    const concertResponse = await axiosPrivate.get(
        `/concertsSchedule/${concertId}`
    );
    const fetchedConcertData = concertResponse.data.map((item: any) => ({
        id: item.idPlanu,
        name: item.nazwa,
        tytul: item.Tytul,
        eventId: item.idWydarzenia,
        duration: convertToMinutes(item.czasTrwania),
        startDate: item.godzinaRozpoczecia,
        position: item.nrKoncertu,
        type: item.idTypu,
        movable: true,
        isCurrent: false,
        kolor: item.kolor,
        bandId: item.idZespolu,
    }));

    const fetchedConcertVersion = await fetchConcertVersion(
        axiosPrivate,
        concertId
    );

    return { fetchedConcertData, fetchedConcertVersion };
};

export const fetchConcertVersion = async (
    axiosPrivate: AxiosInstance,
    concertId: number
) => {
    const concertVersionResponse = await axiosPrivate.get(
        `/concerts/version/${concertId}`
    );
    return concertVersionResponse.data.version;
};

export const POLLING_INTERVAL = parseInt(process.env.REACT_APP_POLLING_INTERVAL_S || "30", 10);
export const MIN_EVENT_HEIGHT = parseInt(process.env.REACT_APP_MIN_EVENT_HEIGHT || "20", 10);
export const MAX_EVENT_HEIGHT = parseInt(process.env.REACT_APP_MAX_EVENT_HEIGHT || "100", 10);
export const EVENT_DURATION_MULTIPLIER = parseInt(process.env.REACT_APP_EVENT_DURATION_MULTIPLIER || "3", 10);
